import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import Countdown from "react-countdown";
import ReactPlayer from "react-player";
import { Link, useHistory } from "react-router-dom";
import { serverInfo } from "../../../../../App";
import flag from "../../../../../assets/images/flag.png";
import clock from "../../../../../assets/images/meetupEvent/clock.png";
import ContdownTimerRender from "../../../../../HelperComponent/ContdownTimerRender";
import "./SuperStarContent.css";
const PendingPostDetails = (props) => {
  const { imageCdnUrl, videoCdnUrl } = useContext(serverInfo);
  const history = useHistory();
  const [event, setEvent] = useState("");

  useEffect(() => {
    let isMounted = true;
    const event_id = props.match.params.id;

    axios
      .get(`/api/admin/learning_session/pending/${event_id}`)
      .then((res) => {
        if (isMounted) {
          if (res.data.status === 200) {
            setEvent(res.data.post);
          }
        }
      });
  }, [props.match.params.slug, history]);

  const startTime = moment(event?.event_date).format("LL") + " " + event.start_time;

  return (
    <>
      <div className="AS">
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-sm-12 col-md-12 col-lg-6 m-0 mb-3">
              <div className="card card-bg p-3 me-2">
             {event.banner ? (
                    <img
                    src={imageCdnUrl + event.banner}
                    alt=""
                    className="img-fluid Banner-SME-b "
                  />
                    
                  
                ) : (
                  <ReactPlayer
                      url={videoCdnUrl + event.video}
                      controls={true}
                      playing={false}
                      volume={1}
                      width="100%"
                    />
                )} 

                <Countdown
                  date={startTime}
                  renderer={ContdownTimerRender}
                />
              </div>
            </div>

            <div className="col-sm-12 col-md-12 col-lg-6 m-0 mb-3">
              <div className="registration-head  card-bg mb-1">
                <h5 className="text-warning fw-bold p-2">Registration </h5>
              </div>

              <div className="row registration-body  card-bg m-0 pt-3">
                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Registration Start:</span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {moment(event.registration_start_date).format("LL")}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Registration End:</span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {moment(event.registration_end_date).format("LL")}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Fees :</span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {event.fee} $
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Assignment :</span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {Number(event.assignment) == 1
                          ? "With Assigmnment"
                          : "Without Assigmnment"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-1">
            <div className="col-md-12">
              <div className="card card-bg shadow">
                <div className="card-body">
                  <h5 className="text-light pb-3">{event.title}</h5>

                  <h5 className="text-warning">Instruction</h5>
                  <div className="under-line"></div>
                  <p className="text-light mt-2">
                    <Markup content={event.instruction} />
                  </p>

                  <h5 className="text-warning">Description</h5>
                  <div className="under-line"></div>
                  <p className="text-light mt-2">
                    <Markup content={event.description} />
                  </p>

                  <div className="col-md-4 card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                    <h5 className="text-warning pt-2 ">Event Date</h5>
                    <p className="text-light fw-bold pt-2">
                      {moment(event.event_date).format("LL")} |{" "}
                      {moment(event.start_time, "HH:mm:ss").format("hh:mm A")}-
                      {moment(event.end_time, "HH:mm:ss").format("hh:mm A")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card card-bg mt-3">
            <div className="row">
              <div className="col-md-4 d-flex justify-content-center align-items-center">
                <img src={clock} className="img-fluid p-3" alt="" />
              </div>
              <div className="col-md-4 d-flex align-items-center">
                <div className="mx-3">
                  <h2 className="text-warning">Event Details submitted</h2>
                  <p className="text-light">
                    &nbsp;
                    {Number(event.status) < 1 ? (
                      <span className="fw-bold">
                        Waiting for Super Star & Manager Approval
                      </span>
                    ) : Number(event.status) < 2 ? (
                      <span className="fw-bold">
                        Waiting for Manager Admin Approval
                      </span>
                    ) : Number(event.status) == 11 ? (
                      <span className="text-warning">Rejected</span>
                    ) : (
                      <>
                        (
                        <span className="text-warning">
                          Approved By Superstar And Manager Admin
                        </span>
                        )
                      </>
                    )}
                    &nbsp;
                  </p>
                </div>
              </div>

              <div
                className="col-md-4"
                style={{ borderLeft: "1px dashed yellow" }}
              >
                <h5 className="text-light text-center my-3">Status</h5>
                <div className="d-flex justify-content-center align-items-center">
                  <div style={{ width: 150, height: 150 }}>
                    {Number(event.status) > 1 && Number(event.status) != 11 ? (
                      <CircularProgressbarWithChildren
                        value={100}
                        styles={buildStyles({ pathColor: `gold` })}
                      >
                        {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                        <div style={{ fontSize: 12, marginTop: -5 }}>
                          <strong className="text-light">100% complete</strong>
                        </div>
                      </CircularProgressbarWithChildren>
                    ) : Number(event.status) === 1 ? (
                      <CircularProgressbarWithChildren
                        value={50}
                        styles={buildStyles({ pathColor: `gold` })}
                      >
                        {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                        <div style={{ fontSize: 12, marginTop: -5 }}>
                          <strong className="text-light">50% complete</strong>
                        </div>
                      </CircularProgressbarWithChildren>
                    ) : (
                      <CircularProgressbarWithChildren
                        value={0}
                        styles={buildStyles({ pathColor: `gold` })}
                      >
                        {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                        <div style={{ fontSize: 12, marginTop: -5 }}>
                          <strong className="text-light">0% complete</strong>
                        </div>
                      </CircularProgressbarWithChildren>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {Number(event.status) < 1 ? (
            <>
              <div className="mt-3 row">
                <div className="col-md-2 mx-auto">
                  <Link
                    to={`/superstar-admin/learning-session/edit/${event.id}`}
                  >
                    <button className="btn btnEditTest w-100 fw-bold px-3 mx-3">
                      Edit
                    </button>
                  </Link>
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default PendingPostDetails;
